import styled from 'styled-components';

export const SelectContainer = styled.div`
  position: relative;
  width: 100%;
  font-size: 16px;
  border-radius: 5px;
  font-family: ${({ theme }) => theme.font.fontFamily.regular};
  font-weight: 100;
  color: #000;
`;

export const SelectHeader = styled.div`
  width: 100%;
  padding: 10px;
  border: none;
  background: #fff;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 5px;
  > span {
    font-size: 12px;
  }
`;

export const OptionList = styled.ul`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #ccc;
  margin-top: 5px;
  padding: 0;
  list-style: none;
  z-index: 1000;
  max-height: 300px;
  overflow-y: auto;
  border-radius: 5px;
`;

export const OptionItem = styled.li`
  padding: 4px;
  cursor: pointer;

  font-size: 12px;

  &:hover {
    background: #efefef;
  }
`;

export const ClearButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: black;
`;